var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-status",on:{"click":_vm.click}},[_c('div',{staticClass:"text"},[(_vm.column.title)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.column.title))]):_vm._e(),_c('b',[_c('span',{class:`status-label`,style:(`color: ${_vm.row[_vm.column.field].cor}`)},[_vm._v(_vm._s(_vm.row[_vm.column.field].descricao))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }